import { gql, useMutation } from '@apollo/client'
import { MutationHookParams } from 'gql/sharedTypes/types'
import { type MatchPayload } from '~/types/smartMatch'

const RUN_SMART_MATCH_JOB_MUTATION = gql`
  mutation RunSmartMatchJob($input: SmartMatchInput!) {
    rerunJobWithSmartMatch(input: $input)
  }
`

interface SmartMatchInput {
  jobId: number
  smartMatches: MatchPayload[]
}

interface RunSmartMatchJobResponse {
  rerunJobWithSmartMatch: boolean
}

export const useRunSmartMatchJobMutation = (options?: MutationHookParams) => {
  const [mutation, { data, loading, error }] = useMutation<RunSmartMatchJobResponse>(
    RUN_SMART_MATCH_JOB_MUTATION,
    {
      ...options,
      refetchQueries: ['ProjectQuery']
    }
  )

  const runSmartMatchJob = async (input: SmartMatchInput) => {
    const response = await mutation({ variables: { input } })
    return response.data?.rerunJobWithSmartMatch ?? false
  }

  return {
    runSmartMatchJob,
    data: data?.rerunJobWithSmartMatch ?? null,
    loading,
    error
  }
}
